import styled, { css } from 'styled-components'

import { color, spacing, typography } from '../../../../themes'

export const Container = styled.li<{ selected?: boolean; active?: boolean }>`
  ${typography('body1')}
  width: 100%;
  padding: ${spacing(4, 6)};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  scroll-margin: ${spacing(1)};
  transition: all 0.2s ease;
  color: ${color('gray.01')};
  background: ${color('white')};

  ${({ selected }) =>
    selected &&
    css`
      color: ${color('white')};
      background: ${color('blue.01')};
    `}

  /* キーボードナビゲーション (focus を input に保持する combobox 等で使用) */
  ${({ active }) =>
    active &&
    css`
      color: ${color('white')};
      background: ${color('blue.01')};
      outline: none;
    `}

  &:hover,
  &:focus {
    color: ${color('white')};
    background: ${color('blue.01')};
    outline: none;
  }
`
